import { useSelector } from 'react-redux';
import { view } from '@yola/ws-sdk';
import getDeviceModeWidth from '../helpers/get-device-mode-width';
import { VIEW_WIDTH_CSS_VAR, VIEW_BORDER_CSS_VAR } from '../constants/common';

const useDeviceModeWidth = () => {
  const deviceMode = useSelector(view.selectors.getDeviceMode);
  const deviceWidth = getDeviceModeWidth(deviceMode);

  const value = deviceWidth ? `${deviceWidth}px` : '100%';
  document.body.style.setProperty(VIEW_WIDTH_CSS_VAR, value);
  document.body.style.setProperty(VIEW_BORDER_CSS_VAR, deviceWidth ? '1px' : '0px');

  return deviceWidth;
};

export default useDeviceModeWidth;
